import { CategoriesBySector } from '../categories-types';

export const CATEGORIES_FESTIVAL: CategoriesBySector = {
  '': undefined,
  ANY: ['all'],
  TEAM: ['all', 'mobility', 'catering', 'accommodation'],
  ARTISTS: ['all', 'mobility', 'catering', 'accommodation', 'cargo'],
  SITE: ['all', 'energy-water-waster', 'equipment-cargo', 'building'],
  PUBLIC: ['catering'],
};
